module.exports = __webpack_public_path__ + "img/404error.afc4145a.jpeg";